// Molecule
import { forwardRef } from "react";
import { Image, ImageProps } from "@repo/ui/image";
import {
  getImageSource,
  getImageSourceSet,
  ImageSizes,
} from "@repo/utils/image-presets";

export type CloudinaryImageProps = ImageProps & {
  url: string;
  srcSize: number;
  sourceSetProfile: ImageSizes;
};

export const CloudinaryImage = forwardRef<
  HTMLImageElement,
  CloudinaryImageProps
>(({ srcSize, sourceSetProfile, ...props }, ref) => {
  const src = getImageSource(props.url, srcSize, sourceSetProfile);
  const srcset = getImageSourceSet(props.url, sourceSetProfile).join(", ");

  return <Image ref={ref} src={src} srcSet={srcset} {...props} />;
});

CloudinaryImage.displayName = "CloudinaryImage";
